module.exports = __webpack_public_path__ + "static/media/thumbnail.397e76c7.jpg";